import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";

function dateFormatter(dt: any) {
  if (dt == "Invalid Date") {
    return null;
  }
  if (dt != null) {
    return dt.toLocaleDateString("fr-CA");
  }
  return dt;
}
export default class SuppliersService {
  private httpClient = makeHttpClient();
  getSuppliersData(query: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<SuppliersService>(env.supplier + "?" + query)
    );
  }

  getAllSuppliersData() {
    return _unwrapAxiosResponse(
      this.httpClient.get<SuppliersService>(env.supplier + "all/?")
    );
  }

  addSupplier(formData: any) {
    const data = {
      code: formData.code,
      name: formData.name
    };
    return _unwrapAxiosResponse(
      this.httpClient.post<SuppliersService>(env.supplier, data)
    );
  }

  editSupplier(formData: any) {
    return _unwrapAxiosResponse(
      this.httpClient.put<SuppliersService>(
        env.supplier + formData.id + "/",
        formData
      )
    );
  }

  deleteSupplier(id: any) {
    return _unwrapAxiosResponse(
      this.httpClient.delete<SuppliersService>(env.supplier + id + "/")
    );
  }
}
